var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react'; // tslint:disable-line

import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('entity-card');
import { ContentNode } from './content-node';
import { CellHeader } from '../elements/cell-header';
import { ImageEntity } from './image-entity';
import { coalesce } from '../../utils/coalesce';
import { entityLabel } from '../../utils/entity-label';
import { ResponsiveContainer } from '../elements/responsive-container';
import { breakpoints, theme } from '@shapeable/theme';
import { Card } from '../elements/card';
import { get, includes } from 'lodash';
import { useLang } from '../../hooks/use-lang';
import { useLink } from '../../hooks/use-link';
export var EntityCardDefaultProps = {
  imageAspectRatio: {
    base: 16 / 9,
    landscape: 21 / 9,
    tablet: 16 / 9
  },
  spaceUnits: 4,
  linkEntireCard: false,
  moreLabel: 'read more',
  linkVariant: 'title-image'
}; // -------- Styles -------->

var CardStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    margin-bottom: ", ";\n  "], ["\n    display: flex;\n    margin-bottom: ", ";\n  "])), theme.UNIT(4))
});
var ContentStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-grow: 1;\n    font-weight: inherit;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "], ["\n    flex-grow: 1;\n    font-weight: inherit;\n    padding-top: ", ";\n    padding-bottom: ", ";\n    margin-top: ", ";\n    ", ";\n  "])), theme.UNIT(3), theme.UNIT(3), theme.UNIT(3), theme.H_DOT_BG())
});
var TitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n    ", "\n  "], ["\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: 500;\n    line-height: 1.25em;\n    margin-bottom: 0;\n    color: ", ";\n    background: none;\n    margin-top: 0;\n    margin-bottom: ", ";\n\n    ", "\n  "])), theme.FONT('sans'), theme.FONT_SIZE(18), theme.COLOR('dark'), theme.UNIT(2), function (_a) {
    var hasLink = _a.hasLink;
    return hasLink && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      &:hover {\n        color: ", ";\n      }\n    "], ["\n      &:hover {\n        color: ", ";\n      }\n    "])), theme.COLOR('link-hover'));
  })
});
var ImageStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n    ", "\n\n    img {\n      object-fit: cover;\n    }\n  "], ["\n    \n    ", "\n\n    img {\n      object-fit: cover;\n    }\n  "])), function (_a) {
    var hasLink = _a.hasLink;
    return hasLink && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      transition: filter 0.2s;\n\n      &:hover {\n        filter: brightness(1.2);\n      }\n    "], ["\n      transition: filter 0.2s;\n\n      &:hover {\n        filter: brightness(1.2);\n      }\n    "])));
  })
});
var ImageContainerStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeaderStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-bottom: ", ";\n  "], ["\n    margin-bottom: ", ";\n  "])), theme.UNIT(1))
});
var FooterStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), theme.H_DOT_BG())
}); // -------- Components -------->

var My = {
  Card: styled(Card)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), CardStyles),
  ImageContainer: styled(ResponsiveContainer)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ImageContainerStyles),
  Image: styled(ImageEntity)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Content: styled(ContentNode)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles),
  Title: styled.span.attrs(cls.attr('title'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Header: styled(CellHeader)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Footer: styled.div.attrs(cls.attr('footer'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles)
};
/**
 * Presents an entity in a 'card' format, which is an image stacked above text and details. This is generally used inside a grid component on listings pages.
 */

export var EntityCard = function EntityCard(props) {
  var className = props.className,
      entity = props.entity,
      target = props.target,
      imageAspectRatio = props.imageAspectRatio,
      maxWords = props.maxWords,
      linkEntireCard = props.linkEntireCard,
      spaceUnits = props.spaceUnits,
      moreLabel = props.moreLabel,
      linkVariant = props.linkVariant;
  var description = coalesce(entity, ['description', 'summary', 'intro', 'content', 'openGraph.description']);
  var image = coalesce(entity, ['banner', 'logo', 'photo']);
  var t = useLang();
  var label = t(props.label || entityLabel(entity));
  var Link = useLink().Link;
  var href = props.href === undefined ? entity.path : props.href;

  if (!image && entity.openGraph && entity.openGraph.image) {
    image = {
      id: "entity-image-" + entity.id,
      image: entity.openGraph.image
    };
  }

  if (!image && get(entity, 'image')) {
    image = {
      id: "entity-image-" + entity.id,
      image: get(entity, 'image')
    };
  }

  var titleElement = React.createElement(My.Title, {
    hasLink: !!href
  }, entity.name);
  var imageLinkStyle = {
    height: '100%',
    width: '100%',
    display: 'block'
  };
  return React.createElement(My.Card, __assign({}, props, {
    href: linkEntireCard && href,
    target: target,
    spaceUnits: spaceUnits,
    className: cls.name(className),
    imageAspectRatio: !props.image && imageAspectRatio,
    image: props.image || image && (linkVariant === 'title-image' && !!href ? React.createElement(Link, {
      style: imageLinkStyle,
      href: href
    }, React.createElement(My.Image, {
      hasLink: true,
      entity: image
    })) : React.createElement(My.Image, {
      entity: image
    }))
  }), React.createElement(My.Header, null, label), !!href && includes(['title', 'title-image'], linkVariant) ? React.createElement(Link, {
    style: {
      textDecoration: 'none'
    },
    href: href
  }, titleElement) : titleElement, props.children, description && React.createElement(My.Content, {
    moreLabel: moreLabel,
    maxWords: maxWords,
    entity: description
  }));
};
EntityCard.defaultProps = EntityCardDefaultProps;
EntityCard.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16;